import React from "react";

function useEventGa() {

  const event = React.useCallback((name_event: string, info: any) => {
    if (typeof window !== "undefined" && typeof window.gtag !== "undefined") {
      window.gtag("event", name_event, { ...info });
    }else{
      console.log("window.gtag is undefined");
    }
  }, []);

  return { event };
}

export default useEventGa;
